import { getFormattedTabNameForAnalytics } from "@/components/cart/CartItemTile/utils"
import {
  ODP_TRACKINGLINK_ANALYTICS_EVENT_NAME,
  ODP_TRACKINGLINK_ANALYTICS_INTERNAL_LINK_NAME,
  ODP_TRACKINGLINK_ANALYTICS_INTERNAL_LINK_POSITION,
} from "@/components/OrderConfirmation/OrderDetailsTabs/constant"
import { pushAnalyticsObjToDataLayer } from "@/utils/helper"
import { isObjectEmpty } from "@/utils/index"

export const getTrackingLinkAnalyticsData = (
  link,
  analyticsData,
  isTabsEnabled = false,
  activeTab = ""
) => {
  const tabName = getFormattedTabNameForAnalytics(activeTab)

  return analyticsData
    ? JSON.stringify({
        eventAction: `${ODP_TRACKINGLINK_ANALYTICS_EVENT_NAME}:${
          isTabsEnabled
            ? ODP_TRACKINGLINK_ANALYTICS_INTERNAL_LINK_NAME
            : "tracking link"
        }`,
        eventName: `${ODP_TRACKINGLINK_ANALYTICS_EVENT_NAME}:${
          isTabsEnabled
            ? ODP_TRACKINGLINK_ANALYTICS_INTERNAL_LINK_NAME
            : "tracking link"
        }`,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: `${
          isTabsEnabled
            ? ODP_TRACKINGLINK_ANALYTICS_INTERNAL_LINK_NAME
            : "tracking link"
        }`,
        internalLinkPosition: isTabsEnabled
          ? ODP_TRACKINGLINK_ANALYTICS_INTERNAL_LINK_POSITION
          : "order history",
        internalLinkType: isTabsEnabled
          ? `${ODP_TRACKINGLINK_ANALYTICS_EVENT_NAME}:${tabName}`
          : "my account:navigation",
        internalLinkZoneName: `${ODP_TRACKINGLINK_ANALYTICS_EVENT_NAME}${
          isTabsEnabled ? `:${tabName}` : ""
        }`,
        internalLinkURL: link
          ? (link.indexOf("http") === -1 ? window.location.origin : "") + link
          : "n/a",
        clickInternalLinks: "true",
      })
    : null
}

export const cartItemSummaryAnalytics = (
  analyticTitleData,
  productInfoData
) => {
  const eventInfo = analyticTitleData ? JSON.parse(analyticTitleData) : {}
  const productInfo = productInfoData ? JSON.parse(productInfoData) : {}
  pushAnalyticsObjToDataLayer(eventInfo, "cmp:click", {}, productInfo)
}

export const cartBundleFinishAnalytics = (
  bundleLocalStorage = "",
  payloadData = {}
) => {
  const bundleItems = bundleLocalStorage ? JSON.parse(bundleLocalStorage) : []
  if (bundleItems.length) {
    const selctedBundle = bundleItems.find(bItem => {
      return (
        Array.isArray(bItem?.selectedSkus) &&
        bItem?.selectedSkus?.includes(payloadData?.sku)
      )
    })
    if (selctedBundle && !isObjectEmpty(selctedBundle)) {
      const updatedBundleItems = bundleItems.map(bItem => {
        if (bItem.bundleId === selctedBundle.bundleId) {
          const selectedSkus = bItem?.selectedSkus.filter(
            sku => sku !== payloadData?.sku
          )
          return {
            ...bItem,
            selectedSkus,
          }
        }
        return bItem
      })
      localStorage.setItem("bundleItems", JSON.stringify(updatedBundleItems))
    }
  }
}
